"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const dayjs_1 = __importDefault(require("dayjs"));
const UserContext_1 = require("context/UserContext");
const useCycle_1 = require("hooks/api/useCycle");
const AnalyticUtils_1 = require("utils/AnalyticUtils");
const FormalReview_1 = require("utils/FormalReview");
const HelperUtils_1 = require("utils/HelperUtils");
const ReviewDeadlineCalendar_1 = __importDefault(require("components/admin/Cycles/add-new-reviewees/fragments/ReviewDeadlineCalendar"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ModalEditReviewDeadline = ({ assignment, onClose, getSidebarData, getUserCycle }) => {
    const { user } = (0, UserContext_1.useUser)();
    const { id } = (0, react_router_1.useParams)();
    const usp = new URLSearchParams(location.search);
    const placementId = usp.get('placement') || '';
    const defaultAssignmentEndsAt = (0, FormalReview_1.getDefaultReviewDeadline)(assignment?.assignmentProgress?.endsAt);
    const [assignmentEndsAt, setAssignmentEndsAt] = (0, react_1.useState)(defaultAssignmentEndsAt);
    const isButtonDisabled = (0, react_1.useMemo)(() => {
        return ((0, HelperUtils_1.getDateLocale)((0, dayjs_1.default)(assignmentEndsAt)) ===
            (0, HelperUtils_1.getDateLocale)((0, dayjs_1.default)(assignment?.assignmentProgress?.endsAt)));
    }, [assignment?.assignmentProgress?.endsAt, assignmentEndsAt]);
    // ** Hook to update review deadline
    const { mutate: editReviewDeadline, isLoading } = (0, useCycle_1.useEditReviewDeadline)(parseInt(id), parseInt(placementId));
    const onClickSubmit = () => {
        const body = {
            endsAt: assignmentEndsAt
        };
        editReviewDeadline(body, {
            onSuccess: () => {
                // ** Close modal
                onClose();
                // ** Track event to amplitude
                (0, AnalyticUtils_1.trackEvent)({
                    event: 'edit user review deadline',
                    eventProperties: {
                        cycleId: id,
                        adminId: user.id,
                        placementId: placementId,
                        reviewDeadline: body.endsAt
                    },
                    env: 'performance'
                });
                // ** Refetch sidebar data
                getSidebarData();
                // ** Refetch users cycle
                getUserCycle();
            }
        });
    };
    return (react_1.default.createElement(Modal_1.default, { minWidth: 400, customClass: "!max-w-[400px]", onClose: onClose },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Edit Review Deadline') }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "px-[24px] mt-[4px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-800 mb-[16px]" }, (0, HelperUtils_1.getObjectiveLocale)('By editing this review deadline, it will change all the deadline for the reviewers in all phases for this reviewee.')),
                react_1.default.createElement(ReviewDeadlineCalendar_1.default, { fullWidth: true, label: "Choose review deadline", value: assignmentEndsAt, onChange: (value) => setAssignmentEndsAt(value) }))),
        react_1.default.createElement(Modal_1.default.Footer, { customClass: "mt-[12px]", useBorder: false, primaryButton: {
                onClick: onClickSubmit,
                isLoading,
                text: 'Submit',
                disabled: isButtonDisabled
            }, secondaryButton: {
                onClick: onClose,
                text: 'Cancel'
            } })));
};
exports.default = ModalEditReviewDeadline;
